import React from 'react';
import './PowerTypeModalHeader.scss';

function PowerTypeModalHeader(props) {
  const { tabData, changeTab, closePowerTypeModal, selectedPowerType } = props;
  const { data, selectedIndex, type } = tabData;
  return (
    <>
      <div className="power-type-modal-header padding-t15 padding-l40 padding-r40 padding-b0">
        <div style={{ display: 'flex' }}>
          {((selectedIndex !== 0 && type !== 'sunglasses') ||
            (type === 'sunglasses' && selectedIndex > 1)) && (
            <div className="icon-header" onClick={() => changeTab(selectedIndex - 1)}>
              <img
                alt="Icon"
                className="cursor-pointer"
                src="https://static.lenskart.com/media/desktop/img/myorder/VectorIcon.svg"
              />
            </div>
          )}
          <div className="power-type-header-title fs28 fw600 text-center">
            {props.frameColour || ''} {props.frameType || ''} {props.frameShape || ''}{' '}
            {props.type || ''}
          </div>
          {closePowerTypeModal && (
            <div onClick={() => closePowerTypeModal()}>
              <img
                alt="close"
                className="cursor-pointer"
                src="https://static.lenskart.com/media/desktop/img/myorder/CrossIcon.svg"
              />
            </div>
          )}
        </div>
        <div className="display-flex text-center justify-content-center margin-t10">
          {data &&
            data.map((tab, index) => {
              const { value, label, disabled } = tab;
              const dontShowTab =
                (type === 'sunglasses' && index === 0) ||
                (selectedPowerType === 'zero_power' && index === 2);
              const dontShowTabBorder =
                index === data.length - 1 || (selectedPowerType === 'zero_power' && index === 1);
              if (dontShowTab) {
                return null;
              }
              return (
                <div
                  key={index}
                  className={`power-tab text-left display-flex ${
                    disabled ? 'power-tab_cursor-not-allowed' : ''
                  }`}
                  onClick={() => !disabled && changeTab(index)}
                >
                  <div
                    className={`info display-flex ${
                      selectedIndex === index ? ' power-tab_enable' : 'bord'
                    }`}
                  >
                    {value && <div className="power-tab_selected">{label}</div>}
                    <div className={`second-headline ${value ? ' highlight-tab' : ''}`}>
                      {value || label}
                    </div>
                  </div>
                  {!dontShowTabBorder && (
                    <div className={`tab-border ${value ? ' space-top' : ''}`}></div>
                  )}
                </div>
              );
            })}
        </div>
      </div>
    </>
  );
}

export default PowerTypeModalHeader;
